// Format an 11-digit ntconnect telephone number ("15615550123") for display.
// Falls back to the raw value for anything that isn't a US 10/11-digit number.
export function formatTelephoneNumber(tn) {
  const digits = String(tn || "").replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return String(tn || "");
}

// 10-digit NANP core — used to match a DID against an inbound route's number
// regardless of a leading country code ("15615550123" / "5615550123" → "5615550123").
export function digits10(s) {
  const d = String(s || "").replace(/\D/g, "");
  return d.length === 11 && d[0] === "1" ? d.slice(1) : d;
}

// The search endpoints pass the upstream body through verbatim and its shape
// isn't documented; observed form is an object keyed by the code:
//   { "239": { country, region, npa }, ... }   (npa search)
//   { "561289": { ..., npa, nxx }, ... }        (npanxx search — likely)
// Handle that plus bare arrays, {npas|npanxx|data:[...]}, and HAL _embedded.
function toArray(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.npas)) return data.npas;
  if (Array.isArray(data.npanxx)) return data.npanxx;
  if (Array.isArray(data.data)) return data.data;
  if (data._embedded && typeof data._embedded === "object") {
    return Object.values(data._embedded).find(Array.isArray) || [];
  }
  if (typeof data === "object") return Object.values(data);
  return [];
}

// Pull unique, sorted 3-digit codes out of a search response, trying the given
// object keys in order for object items (strings/numbers are used directly).
function extractCodes(data, keys) {
  const codes = toArray(data)
    .map((it) => {
      if (it == null) return "";
      if (typeof it === "string" || typeof it === "number") return String(it);
      for (const k of keys) if (it[k] != null) return String(it[k]);
      return "";
    })
    .map((s) => s.replace(/\D/g, ""))
    .filter((s) => /^\d{3}$/.test(s));
  return [...new Set(codes)].sort();
}

export const extractNpas = (data) =>
  extractCodes(data, ["npa", "areacode", "area_code", "code", "value"]);

export const extractNxxs = (data) =>
  extractCodes(data, ["nxx", "prefix", "code", "value"]);
